import { FC, useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import AuthWrapper from '../../common/AuthWrapper';
import CustomInput from '../../common/CustomInput';
import CustomButton from '../../common/CustomButton';
import { useIsMobile } from '../../hooks/useWindowWidth';
import { useLoginUserConfirmMutation, useValidateCodeMutation } from '../../store/services/authApi';
import { useAppSelector } from '../../hooks/redux';

import styles from './CodeValidation.module.scss';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../store/slices/authSlice';

const CodeValidation: FC = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [validateCode] = useValidateCodeMutation();
  const [loginUserConfirmMutation] = useLoginUserConfirmMutation();
  const { firstLoginStep } = useAppSelector(state => state.auth);

  const [resErrors, setResErrors] = useState<{attr: string | null, code: string, detail: string}[] | null>(null);

  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  useEffect(() => {
    if (token) {
      localStorage.setItem('resetPassToken', token);
    }
  }, [token]);

  const initialValues = {
    validationCode: token ?? '',
  };

  const handleSubmit = async (values: { validationCode: string }) => {

    if (firstLoginStep) {
      try {
        const result = await loginUserConfirmMutation({
          email: localStorage.getItem('userEmail'),
          confirmation_code: values.validationCode,
        }).unwrap();
        dispatch(setCredentials({ ...result }));
        navigate("/reset-password");
  
        if (result.access) {
          localStorage.setItem("authToken", result.access);
        }

        setResErrors(null);
      } catch (error) {
        console.error("Error logging in:", error);
        setResErrors((error as any)?.data?.errors || null);
      }
    } else {
      try {
        const result = await validateCode({ token: values.validationCode }).unwrap();
        navigate('/create-new-password');
        setResErrors(null);
      } catch (error) {
        console.error(error);
        setResErrors((error as any)?.data?.errors || null);
      }
    }
  };

  const formikValidate = (values: { validationCode: string }) => {
    const errors: { validationCode?: string } = {};
    return errors;
  }

  return (
    <AuthWrapper btnName='Sign In'>
      <Box className={styles.validationCodeContent}>
        <Typography variant={`${isMobile ? 'h6Bold' : 'h5Bold'}`} className={styles.title}>Verify your code</Typography>
        <Formik
          initialValues={initialValues}
          validate={formikValidate}
          onSubmit={handleSubmit}
        >
          {({ values, errors, handleChange, isSubmitting }) => (
            <Form className={styles.validationCodeForm}>
              <CustomInput
                inputType='text'
                inputName="validationCode"
                inputLabel='Code Verification'
                value={values.validationCode}
                error={errors.validationCode}
                customClass={styles.customInput}
                onChange={handleChange}
              />
              <CustomButton
                btnType='submit'
                customClass={styles.customButton}
                disabled={isSubmitting}
              >
                Verify code
              </CustomButton>

              {resErrors && resErrors.map((error, index) => (
                <Typography key={index} variant='h12' sx={{ color: '#C8102E' }}>
                  {error.detail}
                </Typography>
              ))}
            </Form>)}
        </Formik>
      </Box>
    </AuthWrapper>
  )
};

export default CodeValidation;
